<template>
  <div
    v-if="myRelations && !loading">
    <div
      style="justify-content: space-between"
      class="columns is-gapless row-width-actions-bar is-marginless-bottom is-minH50p is-border">
      <div class="is-flex">
        <transition
          enter-active-class="animated fadeIn fasterx2"
          leave-active-class="animated fadeOut fasterx2"
          mode="out-in">
          <div
            v-if="hasFilter"
            class="column is-narrow has-background-primary has-text-white is-flex">
            <div
              v-if="filters.status.length <= 2 && !(totalPagesChild === 1)"
              class="is-self-centered is-padding-left is-padding-right">
              Résultat : + 50 relation(s)
            </div>
            <div
              v-else-if="filters.status.length === 3"
              class="is-self-centered is-padding-left is-padding-right">
              Résultat : {{ total }} relation(s)
            </div>
            <div
              v-else
              class="is-self-centered is-padding-left is-padding-right">
              Résultat : {{ count }} relation(s)
            </div>
          </div>
        </transition>
      </div>
      <div class="is-flex">
        <div
          class="is-border-left is-border-bottom export_btn_style_rel"
          v-if="(isAdmin && isPromoteur ) || (isPromoteur && currentUser.active_all_contact)">
          <div
            :style="actionLineGroup ? '' : ''"
            style="position: absolute; min-height: 100%; align-items: stretch"
            class="is-flex is-uppercase is-flex-center">
            <a
              style="color: #7A7A7A"
              :style="actionLineGroup ? 'background-color: #FAFAFA' : ''"
              @click="actionLineGroup ? cancelSelect() : selectLine()"
              class="is-nowrap btn-export_rel">Actions Groupées</a>
            <i
              v-if="actionLineGroup && multiselection"
              @click="actionLineGroup ? cancelSelect() : ''"
              class="fas fa-times has-cursor-pointer"
              style="font-weight: 300;"
              :style="actionLineGroup ? 'position: absolute; bottom: calc(50% - 7.5px); right: 20px; z-index: 2' : ''"></i>
          </div>
        </div>
        <div
          class="is-border-left is-border-bottom export_btn_style_rel"
          v-if="(isAdmin && isPromoteur )|| (isPromoteur && currentUser.active_all_contact)">
          <div
            class="btn-export_rel is-uppercase is-nowrap">
            <span style="cursor: default">Exporter Données</span>
          </div>
          <div
            class="additional-options_rel">
            <div
              class="option-export_rel">
              <a
                class="select_style_rel is-align-items-center is-flex is-nowrap"
                @click="exportAllRelation(); cancelSelect()">
                <i
                  style="font-size: 15px; padding: 0px 4px"
                  class="fas fa-file-excel is-padding-right-xsmall"></i>
                <span>Format Excel</span>
              </a>
            </div>
            <!-- <div
              style="width: 100% !important"
              class="option-export_stock">
              <a
                class="select_style_stock"
                @click="">
                <span>Format PDF</span>
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <list-top-bar
      v-else
      :has-filter="hasFilter"
      :count="count"
      label="relations(s)"
      :has-multiselection="false">
    </list-top-bar> -->
    <div class="is-flex is-space-between is-border-left is-border-right has-background-white">
      <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
        <div
          v-if="isPromoteur"
          class="field is-grouped">
          <p
            class="control"
            v-for="status in invitationStatus"
            :key="status.value">
            <label
              class="checkbox checkRadioIsHide"
              :for="status.value">
              <input
                :id="status.value"
                :name="status.name"
                type="checkbox"
                :value="status.value"
                v-model="filters.status"
                @change="updateRelationsFilter">
              <span
                class="tag"
                :class="status.color">
                <span>{{ status.label }}</span><span class="icon"><i
                  class="far"
                  :class="filters.status.includes(status.value) ? 'fa-check-square' : 'fa-square'"></i></span>
              </span>
            </label>
          </p>
        </div>
        <div
          v-else
          class="field is-grouped">
          <p
            class="control"
            v-for="status in invitationStatusPromoteur"
            :key="status.value">
            <label
              class="checkbox checkRadioIsHide"
              :for="status.value">
              <input
                :id="status.value"
                :name="status.name"
                type="checkbox"
                :value="status.value"
                v-model="filters.status"
                @change="updateRelationsFilter">
              <span
                class="tag"
                :class="status.color">
                <span>{{ status.label }}</span><span class="icon"><i
                  class="far"
                  :class="filters.status.includes(status.value) ? 'fa-check-square' : 'fa-square'"></i></span>
              </span>
            </label>
          </p>
        </div>
      </div>
      <div
        style="flex-shrink: 0; align-items: stretch; z-index: 1"
        class="is-flex is-nowrap is-border-left">
        <div
          class="column is-narrow is-paddingless"
          v-if="multiselection && actionLineGroup">
          <a
            style="padding: 16px 37px !important"
            :style="selectedItems.length ? 'background-color: #8dbb7d; color: white; cursor: pointer' : 'cursor: default; color: #D7D7D7'"
            @click="selectedItems.length ? (exportXlsFromMultiselect(service, 'liste-relations'), cancelSelect()) : ''"
            class="btn-export_rel is-uppercase">
            <span class="icon"><i class="fas fa-file-excel"></i></span>
            <span>Exporter Relations</span>
          </a>
        </div>
      </div>
    </div>
    <table-controls-vue
      :has-sticky="true"
      class="is-border">
      <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium has-actionsontd">
        <thead
          v-if="myRelations.length"
          class="has-cells-vcentered">
          <tr class="is-size-6">
            <th
              class="is-paddingless has-text-centered"
              style="z-index:2;">
              <!-- <button
                class="button is-small is-light is-circle is-action"
                v-if="multiselection"
                @click="$store.commit('selectAllMultiselectionItems')">
                <i class="far fa-check-double"></i>
              </button> -->
            </th>
            <th
              class="is-groupcols-1a">
              <span>Société</span>
              <!-- <sortable
                @sort="sort('society', $event)"
                sort-id="society"
                :sort="sortBy.society"
                label="Société"></sortable> -->
              <div class="deco"></div>
            </th>
            <th
              class="is-groupcols-1a">
              <span>Référent</span>
              <div class="deco"></div>
            </th>
            <th
              class="is-groupcols-1a">
              <span>Email</span>
              <div class="deco"></div>
            </th>
            <th
              class="is-groupcols-1a">
              <span>Téléphone</span>
              <div class="deco"></div>
            </th>
            <th
              class="is-groupcols-1a">
              <span>Mandat</span>
              <div class="deco"></div>
            </th>
            <th
              class="is-groupcols-1a">
              <span>Statut</span>
              <div class="deco"></div>
            </th>
            <th
              v-if="isPromoteur"
              class="is-groupcols-1a">
              <span>Dernière connexion</span>
              <div class="deco"></div>
            </th>
            <th
              class="is-groupcols-1a">
              <span>Date invitation</span>
              <div class="deco"></div>
            </th>
            <th
              class="is-groupcols-1a">
              <span></span>
              <div class="deco"></div>
            </th>
          </tr>
        </thead>
        <tbody
          v-if="myRelations && myRelations.length"
          class="has-cells-vcentered">
          <tr>
            <td
              v-if="multiselection"
              colspan="10"
              style="padding: 0">
              <div
                class="is-flex is-nowrap is-align-items-center container_select_multiple_rel">
                <a
                  :style="!selectedItems.length > 0? 'background-color: #219CED' : 'background-color: #8CBB7D'"
                  class="select_multiple_rel"
                  @click="$store.commit('selectAllMultiselectionItems')">
                  <i
                    style="font-size: 17px; padding: 0px 22px 0px 16px"
                    class="far fa-check-double"></i>
                  <span class="is-padding-left-xxsmall">{{ !selectedItems.length > 0 ? 'Cliquez ici pour sélectionner toutes les lignes de la page' : 'Déselectionnez toutes les lignes de la page' }}</span>
                </a>
              </div>
            </td>
          </tr>
          <tr
            v-for="(c, i) in myRelations"
            :key="`${c.account_pk}+${i}`"
            class="is-size-6"
            :id="'e' + c.account_pk"
            :class="(lastOpenedItemPk && lastOpenedItemPk === c.account_pk) ? 'has-status-bar--left has-status-bar--draft' : ''">
            <td class="has-text-centered is-cell-hoverable">
              <router-link
                v-if="!multiselection && c.status == 'accepted' && isPromoteur"
                :to="{name: 'CompanyVue', params: {id: c.account_pk}}">
                <avatar
                  v-if="c"
                  :item="c"
                  :use-picto-custom="'fal fa-user-tie'"
                  :use-picto="'fal fa-user-tie'"
                  :i="i"
                  class="is-medium"></avatar>
                <avatar
                  v-else
                  :item="c"
                  :i="i"
                  class="is-medium"></avatar>
              </router-link>
              <avatar
                v-else-if="!multiselection"
                :item="c"
                :use-picto-custom="'fal fa-user-tie'"
                :use-picto="'fal fa-user-tie'"
                :i="i"
                class="is-medium"></avatar>
              <multiselect-button
                v-else
                :data="c">
              </multiselect-button>
              <!-- <avatar
                v-else
                :item="c"
                :use-picto-custom="'fal fa-user-tie'"
                :use-picto="'fal fa-user-tie'"
                :i="i"
                class="is-medium"></avatar> -->
            </td>
            <td
              v-if="isPromoteur">
              <router-link
                v-if="c.status == 'accepted'"
                :to="{name: 'CompanyVue', params: {id: c.account_pk}}"
                class="fullLink">
                {{ c.account_name }}
              </router-link>
              <span
                v-else-if="c.invitation && c.status === 'pending'">
                {{ c.invitation.name }}
              </span>
              <span v-else>{{ c.name || c.account_name }}</span>
            </td>
            <td
              v-if="!isPromoteur">
              <router-link
                v-if="c.status == 'accepted' && accounts.find(a=>a.name===c.account_name) "
                :to="{name: 'PromoteurPresentation', params: {id: c.account_pk}}"
                class="fullLink">
                {{ c.account_name }}
              </router-link>
              <span v-else>{{ c.name || c.account_name }}</span>
            </td>
            <td v-if="c">
              <router-link
                v-if="c.status != 'pending' && c.status != 'refused' && c.relation.account_two.first_admin && isPromoteur"
                :to="{name: 'UserVue', params: {id: c.relation.account_two.first_admin.pk}}"
                class="fullLink">
                {{ c.relation.account_two.first_admin.last_name + ' ' + c.relation.account_two.first_admin.first_name || c.account_name }}
              </router-link>
              <span v-else>{{ c.account_name }}</span>
            </td>
            <td v-if="c">
              <span
                v-if="c.status != 'pending' && c">
                {{ c.account_email }}</span>
              <span v-else>NC</span>
            </td>
            <td>
              <phone-number
                v-if="c.account_phone"
                :phone="c.account_phone"></phone-number>
              <span v-else>NC</span>
            </td>
            <td v-if="c">
              <span v-if="c.access || c.mandats">
                {{ c.access || c.mandats }}
              </span>
              <span v-else>NC</span>
            </td>
            <td v-if="c">
              <span v-if="c">
                {{ c.status | relationStatus }}
              </span>
            </td>
            <td v-if="isPromoteur">
              <span
                v-if="c.last_login_at">
                {{ c.last_login_at | date }}</span>
              <span v-else>-</span>
            </td>
            <td v-if="c">
              <span v-if="c">
                {{ c.created_on | date }}
              </span>
              <span v-else>-</span>
            </td>
            <td class="has-text-centered">
              <display-button-list
                v-if="c.status === 'accepted' && isPromoteur"
                :buttons="buttonAcceptedPromoteur"
                :force-drop-down="true"
                :data="c.pk">
              </display-button-list>
              <display-button-list
                v-if="c.relation && c.relation.status === 'accepted' && !isPromoteur"
                :buttons="accounts.find(a=>a.name===c.account_name) ? buttonAcceptedCommercial : [buttonAcceptedCommercial[1], buttonAcceptedCommercial[2]]"
                :force-drop-down="true"
                :data="c.pk">
              </display-button-list>
              <display-button-list
                v-if="isPromoteur && c.status === 'pending' && c.relation"
                :buttons="c.message ? buttonPendingPromoteur : [buttonPendingPromoteur[0], buttonPendingPromoteur[2]]"
                :force-drop-down="true"
                :data="c.relation">
              </display-button-list>
              <display-button-list
                v-if="isPromoteur && c.status === 'pending' && c.invitation"
                :buttons="c.message ? buttonPendingPromoteur : [buttonPendingPromoteur[0], buttonPendingPromoteur[2]]"
                :force-drop-down="true"
                :data="c.invitation">
              </display-button-list>
              <display-button-list
                v-if="!isPromoteur && c.status === 'pending' && c.relation"
                :buttons="c.message ? buttonPendingCommercial : [buttonPendingCommercial[0], buttonPendingCommercial[2]]"
                :force-drop-down="true"
                :data="c.relation">
              </display-button-list>
              <display-button-list
                v-if="!isPromoteur && c.status === 'pending' && c.invitation"
                :buttons="c.message ? buttonPendingCommercial : [buttonPendingCommercial[0], buttonPendingCommercial[2]]"
                :force-drop-down="true"
                :data="c.invitation">
              </display-button-list>
              <display-button-list
                v-if="c.status === 'refused' && c.promoteur_pk === currentUser.account.pk"
                :buttons="buttonListRefused"
                :force-drop-down="true"
                :data="c.pk">
              </display-button-list>
            </td>
          </tr>
        </tbody>
      </table>
      <div slot="after-list">
        <div
          v-if="isLoading"
          class="is-w50p has-text-centered is-margin-left-auto is-margin-right-auto">
          <img
            src="/img/loading/spinner2.svg"
            alt="loader">
        </div>
        <div
          v-if="noMoreResult"
          class="is-padding has-text-centered is-margin-left-auto is-margin-right-auto">
          <div class="is-size-7">
            <i>Tous les lots sont affichés.</i>
          </div>
        </div>
      </div>
    </table-controls-vue>
    <div v-show="!myRelations.length">
      <div class="is-padding">
        <h2 class="title is-3 has-text-weight-bold">
          Aucune relation disponible
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import { DefaultValues, GenericList, Multiselection, Filter, FilterGetter } from '@/mixins'
import { cloneDeep } from 'lodash'
import randomColor from 'randomcolor'
import UploadMixin from '../../mixins/UploadMixin'

export default {
  name: 'RelationsList',
  mixins: [DefaultValues, GenericList, Multiselection, Filter, FilterGetter, UploadMixin],
  props: {
    isLoading: Boolean,
    companies: {
      type: Array
    },
    relations: {
      type: Array
    },
    invitations: {
      type: Array
    },
    listElements: {
      type: Object
    },
    noMoreResult: Boolean,
    isProgramView: Boolean,
    isLotView: Boolean,
    isParking: Boolean,
    isOther: Boolean,
    sourceSortBy: {
      type: Object,
      default: () => {}
    },
    totalPagesChild: Number
  },
  data () {
    return {
      avatar: {
        background: 'has-background-success',
        icon: 'fal fa-user-tie'
      },
      setQueryAtStart: true,
      filters: {
        status: ['accepted', 'pending', 'refused']
      },
      initFilters: {
        status: ['accepted', 'pending', 'refused']
      },
      loading: false,
      loadDocuments: this.loadItems,
      service: 'RELATIONS_LINK',
      deleteTitle: 'Suppression relation',
      deleteText: 'Êtes vous sûr de vouloir supprimer la relation ?',
      invitationStatus: [
        { value: 'accepted', label: 'Acceptée', color: 'is-success' },
        { value: 'pending', label: 'En attente', color: 'is-warning' },
        { value: 'refused', label: 'Refusée', color: 'is-danger' }
      ],
      invitationStatusPromoteur: [
        { value: 'accepted', label: 'Acceptée', color: 'is-success' },
        { value: 'pending', label: 'En attente', color: 'is-warning' },
        { value: 'refused', label: 'Refusée', color: 'is-danger' }
      ],
      buttonPendingPromoteur: [
        {
          action: (id) => {
            try {
              const data = this.myRelations.find(relation => relation.relation.pk === id)
              data.type = 'relation'
              this.$router.push({ name: 'NewInvitation', params: { id: data.relation.pk, type: data.type } })
            } catch (err) {
              const data = this.invitations.find(relation => relation.pk === id)
              data.type = 'invitation'
              this.$router.push({ name: 'NewInvitation', params: { id: data.pk, type: data.type, promoteur: !!data.promoteur } })
            }
          },
          icon: 'fa-address-card',
          text: 'Relancer invitation'
        },
        {
          action: (id) => {
            let data = this.myRelations.find(relation => relation.pk === id)
            this.showMessage(data.message)
          },
          icon: 'fa-solid fa-eye',
          text: 'Voir message'
        },
        {
          action: (id) => {
            let data = null
            this.myRelations.find(relation => {
              if (relation.relation && relation.relation.pk === id) {
                data = relation
              } else if (relation.invitation && relation.invitation.pk === id) {
                data = relation
              }
            })
            this.canceledInvitation(data)
          },
          icon: 'fa-trash-alt',
          text: 'Annuler invitation'
        }
      ],
      buttonPendingCommercial: [
        {
          action: (id) => {
            let data = this.myRelations.find(relation => relation.relation.pk === id)
            let status = 'accepted'
            this.updateRelation(data.relation, status)
          },
          icon: 'fa-solid fa-check',
          text: 'Accepter invitation'
        },
        {
          action: (id) => {
            let data = this.myRelations.find(relation => relation.pk === id)
            this.showMessage(data.message)
          },
          icon: 'fa-solid fa-eye',
          text: 'Voir message'
        },
        {
          action: (id) => {
            let data = this.myRelations.find(relation => relation.relation.pk === id)
            let status = 'refused'
            this.updateRelation(data.relation, status)
          },
          icon: 'fa-trash-alt',
          text: 'Refuser invitation'
        }
      ],
      buttonAcceptedPromoteur: [
        {
          action: (id) => {
            let data = this.myRelations.find(relation => relation.pk === id)
            this.$router.push({ name: 'CompanyVue', params: { id: data.account_pk } })
          },
          icon: 'fa-address-card',
          text: 'Fiche société'
        },
        {
          action: (id) => {
            this.deleteItem(id)
          },
          icon: 'fa-trash-alt',
          text: 'Stopper relation'
        }
      ],
      buttonAcceptedCommercial: [
        {
          action: (id) => {
            let data = this.relationsList.find(relation => relation.pk === id)
            this.$router.push({ name: 'PromoteurPresentation', params: { id: data.account_pk } })
          },
          icon: 'fa-address-card',
          text: 'Fiche société'
        },
        {
          action: (id) => {
            let data = this.relationsList.find(relation => relation.pk === id)
            this.sendTicket(data.account_pk)
          },
          icon: 'fa-solid fa-envelope',
          text: 'Contacter promoteur'
        },
        {
          action: (id) => {
            this.deleteItem(id)
          },
          icon: 'fa-trash-alt',
          text: 'Stopper relation'
        }
      ],
      buttonListRefused: [
        {
          action: (id) => {
            let data = this.myRelations.find(relation => relation.pk === id)
            const dataType = 'relation'
            this.$router.push({ name: 'NewInvitation', params: { id: data.relation.pk, type: dataType } })
          },
          icon: 'fa-address-card',
          text: 'Relancer invitation'
        }
      ],
      relationsList: [],
      referent: null,
      myRelationsList: null,
      count: null,
      relationsForExport: [],
      bigExport: false,
      relationsLoading: false,
      actionLineGroup: false,
      fiftyAndMore: null,
      lastCall: 0,
      throttleInterval: 10000
    }
  },
  computed: {
    // ...mapState(['currentUser', 'quickview', 'lastOpenedItemPk']),
    ...mapState({
      currentUser: 'currentUser',
      quickview: 'quickview',
      lastOpenedItemPk: 'lastOpenedItemPk',
      savedFilters: 'savedFilters'
    }),
    ...mapGetters(['isPromoteur', 'isAdmin', 'canUseContactSharing', 'accounts', 'plan']),
    myRelations () {
      // if (this.relations) {
      //   this.relations
      // }
      let list = []
      // this.count = this.listElements.items.length
      if (this.listElements && this.listElements.items.length) {
        this.listElements.items.map(e => {
          let company = null
          if (e.relation !== null) {
            e.mandats = e.relation.pre_access_list.length
            if (e.relation.account_one.pk === this.currentUser.account.pk) {
              e.account_pk = e.relation.account_two.pk
              e.account_name = e.relation.account_two.name
              e.account_email = e.relation.account_two.email
              e.account_phone = e.relation.account_two.phone
              e.last_login_at = e.relation.account_two.last_login_at
              e.status = e.relation.status
              e.created_on = e.relation.created_on
              e.picture = e.relation.account_two.picture
              e.relation.account_two.first_admin = null
              // e.mandats = e.relation.pre_access_list.lenght
            } else {
              e.account_pk = e.relation.account_one.pk
              e.account_name = e.relation.account_one.name
              e.account_email = e.relation.account_one.email
              e.account_phone = e.relation.account_one.phone
              e.last_login_at = e.relation.account_one.last_login_at
              e.status = e.relation.status
              e.created_on = e.relation.created_on
              e.picture = e.relation.account_one.picture
              // e.mandats = e.pre_access_list.lenght
            }
            company = this.companies.find(company => company.pk === e.relation.account_two.pk)
            if (company && 'first_admin' in company) {
              e.relation.account_two.first_admin = company.first_admin
            }
          }
          if (e.invitation !== null) {
            e.type = 'invitation'
            e.status = e.invitation.status
            e.created_on = e.invitation.created_on
            e.invitation.last_login_at = null
            e.mandats = e.invitation.pre_access_list.length
            e.invitation.name = e.invitation.last_name + ' ' + e.invitation.first_name
            e.account_pk = e.invitation.pk
          }
          e.sortingName = e.account_name || (e.invitation && e.invitation.name) || ''
          list.push(e)
        })
        list.sort((a, b) => {
          let nameA = a.sortingName.toUpperCase()
          let nameB = b.sortingName.toUpperCase()
          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        })
      }
      return list
    },
    myInvitations () {
      if (this.invitations && this.invitations.length) {
        return this.invitations.map(x => {
          if ('account_one' in x) {
            let relation = {
              status: x.status,
              pk: x.pk,
              created_on: x.created_on
            }
            if (x.account_one.pk === this.currentUser.account.pk) {
              relation.account_pk = x.account_two.pk
              relation.account_name = x.account_two.name
              relation.account_email = x.account_two.email
              relation.account_phone = x.account_two.phone
              relation.last_login_at = x.account_two.last_login_at
              relation.picture = x.account_two.picture
              relation.mandats = x.pre_access_list.length
            } else {
              relation.account_pk = x.account_one.pk
              relation.account_name = x.account_one.name
              relation.account_email = x.account_one.email
              relation.account_phone = x.account_one.phone
              relation.picture = x.account_one.picture
              relation.mandats = x.pre_access_list.length
            }
            let company = this.companies.find(company => {
              return company.pk === relation.account_pk
            })
            if (company && 'first_admin' in company) {
              relation.first_admin = company.first_admin
            }
            return relation
          } else {
            let name = x.last_name + ' ' + x.first_name
            let invitation = {
              type: 'invitation',
              status: x.status,
              pk: x.pk,
              created_on: x.created_on,
              name,
              email: x.email,
              message: x.message,
              access: x.pre_access_list.length
            }
            return invitation
          }
        })
      } else {
        return []
      }
    },
    byReferent () {
      this.$api.get(this.$resources.USER)
      return this.referent
    },
    today () {
      return moment()
    },
    showSort () {
      if (this.$route.name === 'ProgramLots' || this.$route.name === 'LotVue') {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    myRelations: {
      deep: true,
      handler: function (newVal) {
        this.count = newVal.length
      }
    },
    '$route.query.page' (v) {
      this.cancelSelect()
    }
  },
  created () {
    this.initWidget()
    if ('relationsList' in this.savedFilters) {
      this.loadOnCreate = false
      this.initSavedFilters()
    } else if ('status' in this.$route.query && this.$route.query.status) {
      this.filters.status = this.$route.query.status.isArray ? this.$route.query.status : [this.$route.query.status]
    }
  },
  methods: {
    initWidget () {
      return this.myRelations
    },
    afterSuccessDelete (pk) {
      this.$emit('reload')
    },
    deleteAndReload (id) {
      this.deleteItem(id)
    },
    deleteItemBefore (id, name) {
      this.deleteText = `Cette action entrainera la suppression des mandats, options, dénonciations, ainsi que le partage de contact entre votre entité et celle de votre partenaire. Sans relation, vous ne pourrez plus en générer. Les ventes seront conservées et consultables depuis la liste des ADV.`
      this.deleteItem(id)
    },
    tagColor (value, hue = 'blue') {
      let color = randomColor({
        seed: value,
        hue
      })
      return color
    },
    showMessage (text) {
      return this.$swal({
        title: 'Message',
        html: text,
        showConfirmButton: false,
        showCancelButton: false
      })
    },
    sendTicket (id) {
      let params = {
        defaultSubject: 'other',
        defaultTitle: '',
        promoteur: id
      }
      this.$store.commit('setModal', { mode: 'CREATE_TICKET', params })
    },
    initSavedFilters () {
      this.filters = cloneDeep(this.savedFilters.relationsList)
      if ('status' in this.$route.query && this.$route.query.status) {
        this.filters.status = this.$route.query.status.isArray ? this.$route.query.status : [this.$route.query.status]
      }
      this.updateSimpleFilter()
    },
    canceledInvitation (data) {
      if (data.invitation !== null) {
        this.$emit('canceledInvitation', data.invitation.pk)
      } else {
        this.$emit('deleteRelation', data.pk)
      }
    },
    updateRelation (data, status) {
      this.$emit('updateRelationStatus', data.pk, status)
    },
    updateRelationsFilter () {
      if (this.filters && this.filters.status) {
        this.$emit('updateRelationFilter', this.filters.status)
      }
    },
    beforeGet () {
      for (let key in this.filters) {
        this.$store.commit('setSavedFilters', { from: 'relationsList', name: key, value: this.filters[key] })
      }
    },
    initRelation (type = 'multiple') {
      this.relationSharing = true
      const params = {
        searchKeys: 'ACCOUNT',
        facets: {
          ACCOUNT: []
        },
        selectType: type
      }
      this.openRelationSelectionQuickview(params)
    },
    openUserSelection (type = 'multiple') {
      let params = {
        facets: {
          USER: []
        },
        selectType: type,
        mode: 'store'
      }
      this.openUserSelectionQuickview(params)
    },
    async exportAllRelation () {
      const now = Date.now()
      if (now - this.lastCall < this.throttleInterval) return
      this.lastCall = now
      this.performExport()
    },
    async performExport () {
      let params = {
        type: 'export',
        status: this.filters.status
      }
      this.relationsLoading = true
      try {
        let filtersCopy = { ...this.filters }
        let keysToRemove = []
        for (let key in filtersCopy) {
          if (filtersCopy[key] === null || (Array.isArray(filtersCopy[key]) && filtersCopy[key].length === 0)) {
            keysToRemove.push(key)
          }
        }
        keysToRemove.forEach(key => delete filtersCopy[key])
        let { data } = await this.$api.get(this.$resources.RELATIONS_LINK, params)
        this.relationsForExport = []
        for (let d of data.items) {
          this.relationsForExport.push(d.pk)
        }
        if (this.relationsForExport.length <= 50) {
          this.$store.commit('setSelectedItems', this.relationsForExport)
          this.exportXlsFromMultiselect(this.service, 'liste-relation', null, params)
        } else {
          const statusFilters = {
            filters: filtersCopy,
            account: this.currentUser.account.pk
          }
          const documentName = 'Liste des relations'
          const service = this.service
          this.downloadDocuments(this.relationsForExport, documentName, service, statusFilters)
          this.$toasted.global.success('Vous allez recevoir une notification quand votre fichier sera prêt')
        }
      } catch (e) {
        console.log(e)
        this.relationsLoading = false
        this.$toasted.global.danger('Erreur lors de l\'envoie des relations !')
      }
    },
    selectLine () {
      this.actionLineGroup = true
      this.$store.commit('setMultiselection', !this.multiselection)
    },
    cancelSelect () {
      this.actionLineGroup = false
      this.$store.commit('cancelMultiselection')
    }
  }
}
</script>

<style lang="sass">
.additional-options_rel
  background-color: #FFFFFF
  max-height: 0
  overflow: hidden
  transition: max-height 0.3s ease
  position: absolute
  top: 100%
  right: 0
  width: 100%

.option-export_rel
  background-color: #FFFFFF
  position: relative
  z-index: 3 !important
  border: solid 0.5px #ebebeb
  color: #7a7a7a
  width: 100%
  height: auto
  padding-top: 0
  padding-bottom: 0
  font-size: 1.2rem
  display: flex
  justify-content: center
  align-content: center

.export_btn_style_rel
  width: 217px
  height: 50px
  position: relative

.export_btn_style_rel:hover .additional-options_rel
  max-height: 100px

.select_style_rel
  text-decoration: none !important
  height: 100%
  width: 100%
  text-transform: none !important
  font-size: 11px !important
  font-weight: normal
  font-stretch: normal
  font-style: normal
  line-height: normal
  letter-spacing: normal
  color: #7a7a7a !important
  padding: 1rem

.btn-export_rel
  background-color: #fff
  color: #7a7a7a
  width: 100%
  min-height: 100%
  font-size: 1.2rem
  display: flex
  align-items: center
  padding: 16px 56px

.container_select_multiple_rel
  width: 100%

.select_multiple_rel
  text-decoration: none !important
  padding: 13px
  width: 100%
  color: white

.select_multiple_rel:hover
  color: white
  text-decoration: none
</style>
